import React, { useEffect } from 'react';
import { Redirect, useRouteMatch } from 'react-router';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import { useDispatch, useSelector } from 'react-redux';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { EmploymentState } from '../../employment/employment-model';
import { useBasePath } from '../../../../../global/hooks/useBasePath';
import { ArcRoutes } from '../../../constants/routes';
import { NewHireEnrollmentRoutes } from '../../new-hire-enrollment/models/new-hire-routes';
import { setIsReview, setNewHireStep } from '../new-hire-slice';
import { NewHireStep } from '../models/new-hire-model';
import { useEmploymentInfo } from '../../employment/useEmployment';

/** Test route for new hire review*/
export function NewHireReview() {    
    const dispatch = useDispatch();    
    const routeMatch = useRouteMatch();

    const employmentState = useSelector<TcsmStates, EmploymentState>(state => state.employmentState);
    const employmentInfoLoaded = useEmploymentInfo();
    const currentEmployee = employmentState?.currentEmployee;

    const isStip = !employmentState?.nonStipendiaryEmployment;
    const mapHome = useBasePath(ArcRoutes.ArcRoot);
    const reviewUrl = `${mapHome}${ArcRoutes.NewHireEnrollment}${NewHireEnrollmentRoutes.EmployeeRecord}${isStip ? ArcRoutes.StipNewHire : ArcRoutes.NonStipNewHire}`;

    useEffect(() => {
        if (currentEmployee){
            dispatch(setNewHireStep(NewHireStep.EmploymentCompensationClergy));
            dispatch(setIsReview(true));
        }
	}, [currentEmployee]);    

    if (!currentEmployee) {
		const employeeSelect = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.PeopleRoot}${ArcRoutes.EmployeeSearch}`);
		return (
			<Redirect to=
				{
					{
						pathname: employeeSelect,
						state: {
							actionLink: routeMatch.path,
						},
					}
				}
			/>);
	}

    if (!employmentInfoLoaded) {
        return <LoadingCircle />;
    }    
    
    return <Redirect to={reviewUrl} />;    
}